import { render, staticRenderFns } from "./DashboardMarketPlan.vue?vue&type=template&id=70e0675e&"
import script from "./DashboardMarketPlan.vue?vue&type=script&lang=js&"
export * from "./DashboardMarketPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports